import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfigurationService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/appclient';
import { DashboardContext } from '@sdbn/appclient';
import { Station } from 'src/tmc-yard/client/model/station';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { SacClientContext } from '../../../../model/sac-client.context';
import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { TransportDetailsLayoutService } from 'src/tmc-yard/components/transport-details/transport-details-layout.service';
import { StationSet } from 'src/tmc-yard/client/model/station-set';
import { TransportDetailLayout, TransportDetailMode } from 'src/tmc-yard/common/configuration/transport.configuration';
import { TransportDetailsLayoutConverter } from 'src/tmc-yard/common/components/tmp/transport-details-layout-converter.service';
import { Transport } from 'src/tmc-yard/common/model/transport.model';

@Component({
  selector: 'app-station-transport-details',
  templateUrl: './station-transport-details.component.html',
  styleUrls: ['./station-transport-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StationTransportDetailsComponent implements OnInit {

  TransportDetailMode = TransportDetailMode;

  isLinkTransportsEnabled = true;

  clientParameters = TMCClientParameters;

  get isCallTransportToStationEnabled() {
    return this.transport.messaging.messagingAvailable && !this.isLoading;
  }

  layoutDefinition: TransportDetailLayout;

  isLoading = false;

  responseMessages: ResponseMessage[];

  @Input() dashboardContext: DashboardContext;

  sacClientContext: SacClientContext;
  @Input('sacClientContext') set setSacClientContext(sacClientContext: SacClientContext) {
    this.sacClientContext = sacClientContext;
  }

  @Input() station: Station;

  @Input() stationSet: StationSet;

  @Input() transport: Transport;

  yardConfigSubscription: Subscription;

  constructor(
    private transportDetailsLayoutService: TransportDetailsLayoutService,
    private tmcContextService: TmcContextService,
    public cps: ConfigurationService,
    public translationService: TranslationService,
    transportDetailsLayoutConverter: TransportDetailsLayoutConverter
  ) {
    this.layoutDefinition = transportDetailsLayoutConverter.convert(
      this.transportDetailsLayoutService.createStationAssignmentStationDetailsGridLayout()
    );
    this.isLinkTransportsEnabled = cps.isEnabled(TMCClientParameters.FEATURES_LINK_TRANSPORTS, false);
  }

  ngOnInit(): void {
  }

  handleChange() {
    this.tmcContextService.forceRefreshOfStationUsages();
  }

}
